module.exports = __webpack_public_path__ + "media/05_hollow.45da3e45.mp3";